import { GlobalConstants } from "../../data/GlobalConstants";
import { handleResponse } from "../../util/functions";
import { getToken } from "../../helpers/helperJWT";
import { loaderService } from "../loaderService";

const url = GlobalConstants.urlApi;

const getDataPopUps = (data) => {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/popUps/getDataPopUps`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const deletePopUp = (data) => {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/popUps/deletePopUp`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const updatePopUp = (data) => {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/popUps/updatePopUp`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const savePopUp = (data) => {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/popUps/savePopUp`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const updateStatePopUp = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/popUps/updateStatePopUp`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const saveImagen = ({file, idPopUp, extension, nombreImg}) => {
    const formData = new FormData();

    formData.append('id', idPopUp.toString());
    formData.append('extension', extension);
    formData.append('nombreImg', nombreImg);
    formData.append('img', file);

    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': getToken()
        },
        body: formData
    };

    return fetch(`${url}/unoauno/popUps/saveImagen`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

export const popUpsService = {
    getDataPopUps,
    deletePopUp,
    updatePopUp,
    savePopUp,
    updateStatePopUp,
    saveImagen
};